import testimonials from "./components/testimonials";
import projects from "./components/projects";
import loadIn from "./components/loadIn";
import hero from "./components/hero";
import infiniteScroll from "./components/infinite-scroll";
import hamburger from "./components/hamburger";
import lazyLoading from "./components/lazy-loading";



document.addEventListener("DOMContentLoaded", () => {
    const ll = lazyLoading();
    testimonials();
    projects();
    loadIn();
    hero();
    infiniteScroll(ll);
    hamburger();
});
